<template>
  <div style="height: calc(100% - 20px); padding-top: 16px">
    <div class="fullheight">
      <eco-table
        @load="loadData"
        :data="data"
        :pageResult="pageResult"
        :selection="true"
        :default-sorter="[{ direction: 'DESC', property: 'r.UPDATE_TIME_' }]"
        :quick-search-props="[
          {
            label: '',
            prop: 'r.NAME_'
          },
          {
            label: '',
            prop: 'r.CODE_'
          },
          {
            label: '',
            prop: 'u.FULLNAME_'
          },
          {
            label: '',
            prop: 'u.ACCOUNT_'
          },
          {
            label: '',
            prop: 'u.USER_NUMBER_'
          }
        ]"
        ref="roleTable"
        :show-custom-column="false"
        :show-export="false"
      >
        <template v-slot:toolbar>
          <el-dropdown class="dropdown1">
            <el-button size="small" type="primary">导入角色 <i class="el-icon-arrow-down el-icon--right"></i></el-button>

            <el-dropdown-menu slot="dropdown">
              <el-dropdown-item @click.native="iExport">下载角色模板</el-dropdown-item>
              <el-dropdown-item @click.native="iImport">导入角色</el-dropdown-item>
            </el-dropdown-menu>
          </el-dropdown>

          <el-dropdown class="dropdown1">
            <el-button>角色统计表<i class="el-icon-arrow-down el-icon--right"></i></el-button>
            <el-dropdown-menu slot="dropdown">
              <el-dropdown-item @click.native="iExportRole('${uc}/api/role/v1/export_user_role')">用户/角色统计表</el-dropdown-item>
              <el-dropdown-item @click.native="iExportRole('${portal}/portal/sysIndexLayoutManage/sysIndexLayoutManage/v1/export_role_layout')"
                >门户/角色统计表</el-dropdown-item
              >
              <el-dropdown-item @click.native="iExportRole('${portal}/sys/sysMenu/v1/export_rule_menu')">权限/角色统计表</el-dropdown-item>
              <el-dropdown-item @click.native="iExportRole('${uc}/api/role/v1/export_role_scope')">数据权限/角色统计表</el-dropdown-item>
            </el-dropdown-menu>
          </el-dropdown>
          <el-button @click="showDialog()" style="margin-left: 10px">添加</el-button>
          <fe-delete-button :url="roleDeleteUrl" :htTable="$refs.roleTable">删除</fe-delete-button>
        </template>
        <template>
          <eco-table-column type="index" width="50" align="center" label="序号" />
          <eco-table-column prop="id" label="主键" :sortable="true" hidden />
          <eco-table-column prop="name" label="名称" :sortable="true" :show-overflow-tooltip="true"> </eco-table-column>
          <eco-table-column prop="code" label="编码" :sortable="true" />
          <eco-table-column
            prop="enabled"
            label="状态"
            :filters="[
              { text: '启用', value: 1 },
              { text: '禁用', value: 0 }
            ]"
          >
            <template v-slot="{ row }">
              <el-tag type="success" v-if="row.enabled == 1">启用</el-tag>
              <el-tag type="danger" v-else>禁用</el-tag>
            </template>
          </eco-table-column>
          <eco-table-column prop="description" label="描述"> </eco-table-column>
          <eco-table-column prop="dataScope" label="数据范围">
            <template v-slot="{ row }">
              <span v-if="row.dataScope == 1">全部数据范围</span>
              <span v-else-if="row.dataScope == 7">项目数据权限-部门</span>
              <span v-else-if="row.dataScope == 8">项目数据权限-岗位</span>
              <span v-else-if="row.dataScope == 2">项目数据权限-人员</span>
              <span v-else-if="row.dataScope == 3">自定义数据权限</span>
              <span v-else-if="row.dataScope == 4">部门及以下数据权限</span>
              <span v-else-if="row.dataScope == 5">部门数据权限</span>
              <span v-else-if="row.dataScope == 6">仅本人数据权限</span>
            </template>
          </eco-table-column>
          <eco-table-column label="操作" width="600">
            <template v-slot="{ row }">
              <el-link type="primary" :underline="false" class="dataBtn" @click="handleCommand({ row: row, command: 'edit' })"> 编辑 </el-link>
              <el-link type="primary" :underline="false" class="dataBtn" @click="handleCommand({ row: row, command: 'assignUser' })"> 分配用户 </el-link>
              <el-dropdown size="mini" class="dropdownBtn" @click="handleCommand({ row: row, command: 'assignMenu' })" @command="handleCommand">
                <el-link type="primary" :underline="false"> 菜单权限<i class="el-icon-arrow-down el-icon--right"></i> </el-link>
                <el-dropdown-menu slot="dropdown">
                  <el-dropdown-item :command="{ row: row, command: 'assignMenu' }">菜单权限</el-dropdown-item>
                  <el-dropdown-item :command="{ row: row, command: 'exportMenu' }">导出</el-dropdown-item>
                  <el-dropdown-item :command="{ row: row, command: 'copyRoleMenuPerm' }">复制</el-dropdown-item>
                </el-dropdown-menu>
              </el-dropdown>
              <el-link type="primary" :underline="false" class="dataBtn" @click="handleCommand({ row: row, command: 'assignPortal' })"> 门户权限 </el-link>
              <el-link type="primary" :underline="false" class="dataBtn" @click="showDataDialog(row)"> 数据权限 </el-link>
              <el-link type="primary" :underline="false" class="dataBtn" @click="showReportDialog(row)"> 报表权限 </el-link>
            </template>
          </eco-table-column>
        </template>
      </eco-table>

      <eco-sidebar-dialog destroy-on-close width="28%" title="添加角色" :visible="dialogVisible" :before-close="handleClose" append-to-body>
        <el-form v-model="role" data-vv-scope="editRoleForm" style="padding: 20px">
          <eco-form-item label="角色名称" prop="name" label-width="100px">
            <eco-input v-model="role.name" autocomplete="off" :validate="{ required: true }" placeholder="请输入名称"></eco-input>
          </eco-form-item>
          <eco-form-item label="角色别名" prop="code" label-width="100px">
            <eco-input
              v-model="role.code"
              v-pinyin="role.name"
              autocomplete="off"
              :validate="{ required: true, alpha_num: true }"
              placeholder="请输入别名"
              :disabled="role.id ? true : false"
            ></eco-input>
          </eco-form-item>
          <eco-form-item label="状态" label-width="100px">
            <eco-select
              v-model="role.enabled"
              :options="[
                { key: 0, value: '禁用' },
                { key: 1, value: '启用' }
              ]"
              :validate="{ required: true }"
            />
          </eco-form-item>
          <eco-form-item label="描述" label-width="100px">
            <eco-input :maxlength="50" type="textarea" v-model="role.description" placeholder="请输入描述" />
          </eco-form-item>
        </el-form>
        <div class="demo-drawer__footer">
          <el-button @click="dialogCancle('dialogVisible')">{{ $t('eip.common.cancel') }}</el-button>
          <fe-submit-button
            :url="saveRoleUrl"
            :model="role"
            :is-submit="isSubmit"
            :request-method="requestMethod"
            scope-name="editRoleForm"
            @before-save-data="beforeSaveData"
            @after-save-data="afterSaveData"
            >{{ $t('eip.common.save') }}</fe-submit-button
          >
        </div>
      </eco-sidebar-dialog>
      <eco-sidebar-dialog width="28%" title="添加数据权限" :visible="dataDialog" :before-close="handleClosedataDialog" append-to-body destroy-on-close>
        <el-form v-model="dataObj" data-vv-scope="dataForm" v-if="dataDialog" style="padding: 20px">
          <eco-form-item label="数据范围" label-width="100px">
            <eco-select
              v-model="dataObj.dataScope"
              :options="[
                { key: 1, value: '全部数据范围' },
                { key: 7, value: '项目数据权限-部门' },
                { key: 8, value: '项目数据权限-岗位' },
                { key: 2, value: '项目数据权限-人员' },
                { key: 3, value: '自定义数据权限' },
                { key: 4, value: '部门及以下数据权限' },
                { key: 5, value: '部门数据权限' },
                { key: 6, value: '仅本人数据权限' }
              ]"
              :validate="{ required: true }"
            />
          </eco-form-item>
          <eco-form-item label="数据权限" label-width="100px" v-if="dataObj.dataScope == 3">
            <div class="dataObjHeight">
              <eco-select v-model="selectOrgId" class="org-select" :options="orgList" @change="demChange" />
              <el-tree
                :default-checked-keys="dataObj.orgIdList"
                :data="treeData"
                :props="defaultProps"
                node-key="id"
                highlight-current
                default-expand-all
                :expand-on-click-node="false"
                :support-filter="true"
                :check-strictly="true"
                @node-click="orgTreeClick"
                @refresh="handleRefresh"
                @check="check"
                show-checkbox
                ref="ecoTree"
                class="orgTree"
              >
              </el-tree>
            </div>
          </eco-form-item>
          <eco-form-item label="数据权限" label-width="100px" v-if="dataObj.dataScope == 8">
            <div style="border-radius: 4px; border: 1px solid #dcdfe6; padding: 10px">
              <el-row>
                类型：
                <eco-select
                  v-model="dataScopeType"
                  class="type-select"
                  :options="[
                    { key: 1, value: '设计' },
                    { key: 2, value: '施工' }
                  ]"
                  @change="postTypeChange"
                />
              </el-row>
              <el-row style="margin-top: 5px">
                岗位：
                <el-select v-model="postKeys" multiple filterable clearable :validate="{ required: true }" placeholder="请选择">
                  <el-option v-for="item in zwDicData" :key="item.key" :label="item.name" :value="item.key"> </el-option>
                </el-select>
              </el-row>
            </div>
          </eco-form-item>
        </el-form>
        <div class="demo-drawer__footer">
          <el-button @click="dialogCancle('dataDialog')">{{ $t('eip.common.cancel') }}</el-button>
          <fe-submit-button
            :url="dataUrl"
            :model="dataObj"
            :is-submit="isSubmit"
            :request-method="'PUT'"
            scope-name="dataForm"
            @before-save-data="beforeSaveDataD"
            @after-save-data="afterSaveData"
            >{{ $t('eip.common.save') }}</fe-submit-button
          >
        </div>
      </eco-sidebar-dialog>
      <eco-sidebar-dialog width="28%" title="添加报表权限" :visible="reportDialog" :before-close="handleClosereportDialog" append-to-body destroy-on-close>
        <el-form v-model="reportObj" data-vv-scope="reportForm" v-if="reportDialog" style="padding: 20px">
          <eco-form-item label="数据范围" label-width="100px">
            <eco-select
              v-model="reportObj.reportScope"
              :options="[
                { key: 1, value: '全部数据范围' },
                { key: 4, value: '部门及以下' },
                { key: 8, value: '部门及项目' },
              ]"
              :validate="{ required: true }"
            />
          </eco-form-item>
        </el-form>
        <div class="demo-drawer__footer">
          <el-button @click="dialogCancle('reportDialog')">{{ $t('eip.common.cancel') }}</el-button>
          <fe-submit-button
            :url="reportUrl"
            :model="reportObj"
            :is-submit="isSubmit"
            :request-method="'PUT'"
            scope-name="reportForm"
            @before-save-data="beforeSaveReport"
            @after-save-data="afterSaveReport"
            >{{ $t('eip.common.save') }}</fe-submit-button
          >
        </div>
      </eco-sidebar-dialog>
      <eco-sidebar-dialog
        destroy-on-close
        width="28%"
        title="菜单权限复制"
        :visible="dialogVisibleMenuPerm"
        :before-close="handleCloseMenuPerm"
        ref="menuPermSidebardialog"
        append-to-body
      >
        <el-form :model="menuPerm" data-vv-scope="RoleMenuPermForm" style="padding: 20px">
          <eco-form-item label="原角色名称" prop="name" label-width="120px">
            <eco-input v-model="menuPerm.name" permission="r"></eco-input>
          </eco-form-item>
          <eco-form-item label="原角色别名" prop="code" label-width="120px">
            <eco-input v-model="menuPerm.code" permission="r"></eco-input>
          </eco-form-item>
          <eco-form-item label="权限复制角色" label-width="120px">
            <el-select v-model="menuPerm.newCodes" multiple filterable clearable :validate="{ required: true }" placeholder="请选择">
              <el-option v-for="item in roleCodesOptions" :key="item.key" :label="item.value" :value="item.key"> </el-option>
            </el-select>
          </eco-form-item>
        </el-form>
        <div class="demo-drawer__footer">
          <el-button @click="dialogCancle('dialogVisibleMenuPerm')">{{ $t('eip.common.cancel') }}</el-button>
          <fe-submit-button :url="saveRoleCopy" :isSubmit="isSubmit" scopeName="RoleMenuPermForm" @after-save-data="dialogVisibleMenuPerm = false">{{
            $t('eip.common.save')
          }}</fe-submit-button>
        </div>
      </eco-sidebar-dialog>

      <el-dialog
        width="70%"
        style="height: 500px"
        title="导入角色"
        class="sp-manager__dialog"
        :visible="importShow"
        :close-on-click-modal="false"
        :before-close="beforeCloseimport"
        @dialogclose="beforeCloseimport"
        :destroy-on-close="true"
        append-to-body
      >
        <div slot="title" class="dialog-header-title">
          <span class="name">导入角色</span>
        </div>
        <eip-import-material
          model-name="importList"
          permission="w"
          propConf='[{"name":"prop1"}]'
          accept="xlsx,xls"
          limit="1"
          displayType="table"
          :multiple="false"
          :importsuccess="true"
          :importurl="importurl"
        >
          <span slot="labeldesc">导入角色</span>
        </eip-import-material>
        <span slot="footer" class="dialog-footer">
          <el-button @click="beforeCloseimport" type="primary">完 成</el-button>
        </span>
      </el-dialog>

      <fe-load-data ref="feLoadData" :url.sync="loadDataUrl" context="uc" @after-load-data="afterLoadData"></fe-load-data>
      <!-- 角色用户管理 -->
      <user-role-manager append-to-body ref="userRoleManager"></user-role-manager>
      <!-- 菜单授权 -->
      <role-menu-auth append-to-body ref="roleMenuAuth"></role-menu-auth>
      <!-- 接口授权 -->
      <role-method-auth append-to-body ref="roleMethodAuth"></role-method-auth>
      <!-- 用户门户管理 -->
      <user-portal-manager append-to-body ref="userPortalManager"></user-portal-manager>
    </div>
  </div>
</template>
<script>
import uc from '@/api/uc.js'
import org from '@/api/org.js'
import utils from '@/eco-ui-util.js'
import eipImportMaterial from '@/components/eipControl/EipImportMaterial.vue'
import eipUserDialog from '@/components/dialog/EipUserDialog.vue'
const userRoleManager = () => import('@/views/uc/UserRoleManager.vue')
const roleMenuAuth = () => import('@/views/uc/RoleMenuAuth.vue')
const roleMethodAuth = () => import('@/views/uc/RoleMethodAuth.vue')
const userPortalManager = () => import('@/views/uc/UserPortalManager.vue')
import { mapState } from 'vuex'
import portalApi from '@/api/portal'

export default {
  components: {
    eipUserDialog,
    userRoleManager,
    roleMenuAuth,
    roleMethodAuth,
    eipImportMaterial,
    userPortalManager
  },
  computed: {
    ...mapState({
      currentUser: (state) => state.user.currentUserDetail
    }),
    roleDeleteUrl: function () {
      return window.context.uc + '/api/role/v1/role/deleteRoleByIds'
    },
    dataUrl: function () {
      return window.context.uc + '/api/role/v1/role/updateRole'
    },
    reportUrl: function () {
      return window.context.uc + '/api/role/v1/role/updateRole'
    },
    saveRoleUrl: function () {
      let preUrl = window.context.uc + '/api/role/v1/role'
      if (this.role.id) {
        preUrl += '/updateRole'
      } else {
        preUrl += '/addRole'
      }
      return preUrl
    },
    requestMethod: function () {
      return this.role.id ? 'PUT' : 'POST'
    },
    roleCodesOptions: function () {
      let result = []
      for (let role of this.allowRoles) {
        let obj = {}
        obj.key = role.code
        obj.value = role.name
        result.push(obj)
      }
      return result
    },
    saveRoleCopy: function () {
      return `${window.context.portal}/sys/sysRoleAuth/v1/saveCopy?oldCode=${this.menuPerm.code}&newCodes=${this.menuPerm.newCodes}`
    }
  },
  data() {
    return {
      rowInfo: {},
      selectOrgId: '',
      orgList: [], //下拉框待选择的组织
      demList: [], //下拉框待选择的维度
      treeData: [], //树形菜单展示的数组
      postKeys: [],
      dataScopeType: 1,
      defaultProps: {
        children: 'children',
        label: 'name'
      },
      reportObj: {},
      reportDialog:false,
      dataObj: {},
      dataDialog: false,
      dialogVisible: false,
      dialogVisibleMenuPerm: false,
      role: {
        name: '',
        code: '',
        enabled: 1
      },
      isSubmit: true,
      data: [],
      pageResult: {
        page: 1,
        pageSize: 50,
        total: 0
      },
      loadDataUrl: '',
      menuPerm: {},
      allowRoles: [],
      importShow: false,
      importurl: '/api/role/v1/importXlsx',
      formatterBase: [],
      nameList: [],
      zwDicData: []
    }
  },
  mounted() {
    this.$validator = this.$root.$validator
    this.getAllDemList()
    if (this.dataScopeType === 1) {
      this.getDic('sjxmzw')
    } else if (this.dataScopeType === 2) {
      this.getDic('zw')
    } else {
      this.getDic('sjxmzw')
    }
  },
  methods: {
    // 点击下拉菜单
    iExportRole(url) {
      this.$http.get(url, 'arraybuffer').then((resp) => {
        if (resp.data.byteLength > 500) {
          this.$message.info('导出成功')
        } else {
          this.$message.warning('导出失败')
        }
      })
    },
    // 数据权限-选择部门
    getAllDemList() {
      org
        .getDescAll()
        .then((rep) => {
          for (var i = 0; i < rep.length; i++) {
            this.orgList.push({
              key: rep[i].id,
              value: rep[i].demName
            })
            this.demList.push({
              key: rep[i].code,
              value: rep[i].demName
            })
            if (rep[i].isDefault === 1) {
              this.selectOrgId = rep[i].id
              return this.selectOrgId
            }
          }
        })
        .then((params) => {
          var dem = {
            demId: params
          }
          org.getByParentAndDemToTree(dem).then((data) => {
            this.formatterBase = data
            this.treeData = utils.tile2nest(data)
            this.$forceUpdate()
          })
        })
    },
    demChange(data) {
      this.selectOrgId = data
      this.loadTreeData()
    },
    postTypeChange(data) {
      this.zwDicData = []
      this.postKeys = []
      if (data === 1) {
        this.getDic('sjxmzw')
      } else if (data === 2) {
        this.getDic('zw')
      }

      if (this.dataObj.dataScopeType == data) {
        this.postKeys = this.dataObj.orgIdList
      }
    },
    orgTreeClick(orgbytree) {
      //重置数据
      let ary = this.$refs.ecoTable.querys
      for (var i = 0; i < ary.length; i++) {
        if (ary[i].group && ary[i].group == 'orgTree') {
          ary.remove(ary[i])
        }
      }
      if (!orgbytree.code) {
        this.$refs.ecoTable.querys.push({
          property: 'DEM_ID_',
          value: orgbytree.demId,
          group: 'orgTree',
          relation: 'AND',
          operation: 'EQUAL'
        })
      } else {
        let ids = []
        let trees = ''
        this.getOrgTrees(orgbytree, ids)
        trees = ids.join(',')
        if (trees != '') {
          this.$refs.ecoTable.querys.push({
            property: 'ORG_ID_',
            value: trees,
            group: 'orgTree',
            relation: 'AND',
            operation: 'IN'
          })
        }
      }
      this.$refs.ecoTable.load()
    },
    handleRefresh(cb) {
      this.loadTreeData(cb)
      //重置数据
      let ary = this.$refs.ecoTable.querys
      for (var i = 0; i < ary.length; i++) {
        if (ary[i].group && ary[i].group == 'orgTree') {
          ary.remove(ary[i])
        }
      }
      this.$refs.ecoTable.load()
    },
    // 部门选中后赋值
    check(node, section) {
      if (section && section.checkedKeys && section.checkedKeys.indexOf(node.id) > -1) {
        if (node.children && node.children.length > 0) {
          node.children.forEach((a) => {
            this.setChecked(a)
          })
        }
        if (node.parentId) {
          this.setParent(node.parentId)
        }
      } else {
        if (node.children && node.children.length > 0) {
          node.children.forEach((a) => {
            this.setUnChecked(a)
          })
        }
        // if (node.parentId) {
        //   const selectTree = this.$refs.ecoTree.getCheckedNodes().map(obj => {
        //     return obj.id;
        //   });
        //   this.checkParent(node.parentId, selectTree);
        // }
      }
    },
    checkParent(id, section) {
      const parent = this.formatterBase.find((m) => m.id == id)
      let childrenCheck = 0
      if (parent.children && parent.children.length > 0) {
        parent.children.forEach((v) => {
          if (section && section.indexOf(v.id) > -1) {
            childrenCheck++
          }
        })
      }
      if (childrenCheck == 0) {
        this.$refs.ecoTree.setChecked(parent.id, false, false)
      }
      if (parent.parentId) {
        const selectTree = this.$refs.ecoTree.getCheckedNodes().map((obj) => {
          return obj.id
        })

        this.checkParent(parent.parentId, selectTree)
      }
    },
    setParent(id) {
      if (id != '0') {
        const parent = this.formatterBase.find((m) => m.id == id)
        this.$refs.ecoTree.setChecked(parent.id, true, false)
        if (parent.parentId) {
          this.setParent(parent.parentId)
        }
      } else {
        this.$refs.ecoTree.setChecked(id, true, false)
      }
    },
    setChecked(item) {
      if (item.id) {
        this.$refs.ecoTree.setChecked(item.id, true, false)
        if (item.children && item.children.length > 0) {
          item.children.forEach((a) => {
            this.setChecked(a)
          })
        }
      }
    },
    setUnChecked(item) {
      if (item.id) {
        this.$refs.ecoTree.setChecked(item.id, false, false)
        if (item.children && item.children.length > 0) {
          item.children.forEach((a) => {
            this.setUnChecked(a)
          })
        }
      }
    },
    // 获取部门
    loadTreeData(cb) {
      // var param = {
      //   demId: this.selectOrgId
      // }
      // org.getByParentAndDemToTree(param).then((data) => {
      //   this.formatterBase = data
      //   this.treeData = utils.tile2nest(data)
      //   cb && cb()
      // })
    },
    getOrgTrees(node, ids) {
      ids.push(node.id)
      let arr = node.children
      if (arr) {
        for (var i = 0; i < arr.length; i++) {
          this.getOrgTrees(arr[i], ids)
        }
      }
    },
    getDic(key) {
      portalApi.getByTypeKey(key).then((response) => {
        this.zwDicData = response
      })
    },
    //报表权限
    showReportDialog(row) {
      this.postKeys = []
      uc.getRoleDetail(row.code).then((response) => {
        this.reportObj = {}
        this.reportObj = response
        this.reportDialog = true
      })
    },
    showDataDialog(row) {
      this.postKeys = []
      uc.getRoleDetail(row.code).then((response) => {
        this.dataObj = {}
        this.dataObj = response
        this.dataDialog = true

        if (this.dataObj.dataScopeType === 1) {
          this.getDic('sjxmzw')
          this.dataScopeType = this.dataObj.dataScopeType
          this.postKeys = this.dataObj.orgIdList
        } else if (this.dataObj.dataScopeType === 2) {
          this.getDic('zw')
          this.dataScopeType = this.dataObj.dataScopeType
          this.postKeys = this.dataObj.orgIdList
        } else {
          this.getDic('sjxmzw')
          this.dataScopeType = 1
          this.postKeys = []
        }
      })
    },
    iExport() {
      let param = []
      this.$http.get('${business}/system/context/template?fileKey=export-template/角色导入模板.xlsx', 'arraybuffer').then((resp) => {})
    },
    iImport() {
      this.importShow = true
    },
    beforeCloseimport() {
      this.importShow = false
    },
    handleClose() {
      this.dialogVisible = false
    },
    handleClosedataDialog() {
      this.dataDialog = false
    },
    handleClosereportDialog() {
      this.reportDialog = false
    },
    handleCloseMenuPerm() {
      this.dialogVisibleMenuPerm = false
    },
    showDialog(row) {
      this.dialogVisible = true
      if (row) {
        // this.role = row;
        //setTimeout(() => this.$validator.validateAll());
        this.loadDataUrl = `/api/role/v1/role/getRole?code=${row.code}`
      } else {
        this.role = { name: '', code: '', enabled: 1 }
      }
    },
    dialogCancle(dialogVisible) {
      this[dialogVisible] = false
    },
    loadData(param, cb) {
      uc.getRolePage(param)
        .then((response) => {
          this.data = response.rows
          this.pageResult = {
            page: response.page,
            pageSize: response.pageSize,
            total: response.total
          }
        })
        .finally(() => cb())
    },
    handleCommand(params) {
      switch (params.command) {
        case 'edit':
          this.showDialog(params.row)
          break
        case 'delete':
          break
        case 'assignUser':
          this.$refs.userRoleManager.showDialog(params.row.code)
          break
        case 'assignMenu':
          this.$refs.roleMenuAuth.showDialog(params.row.code)
          break
        case 'exportMenu':
          this.exportMenu(params.row)
          break
        case 'methodAuth':
          this.$refs.roleMethodAuth.showDialog(params.row.code)
          break
        case 'copyRoleMenuPerm':
          this.menuPerm = params.row
          this.dialogVisibleMenuPerm = true
          this.loadDataUrl = `/api/role/v1/roles/getNotCodeAll?code=${params.row.code}`
          break
        case 'assignPortal':
          this.$refs.userPortalManager.showDialog(params.row.code)
          break
        default:
          break
      }
    },
    async beforeSaveData() {
      //  提交前可以改变model中的数据
      // this.role
      // this.isSubmit 是否提交数据到后台
      // this.isSubmit = true  提交数据到后天
      // this.isSubmit = false 不提交
      // this.isSubmit = false;
      // console.log(new Date().getTime());
      // for(let i=0; i<1000000000;i++){

      // }
      //  console.log(new Date().getTime());

      this.isSubmit = true
    },
    async beforeSaveDataD() {
      if (this.dataObj.dataScope == 3 && this.$refs.ecoTree && this.$refs.ecoTree.getCheckedKeys()) {
        this.dataObj.orgIdList = this.$refs.ecoTree.getCheckedKeys()
      } else if (this.dataObj.dataScope == 8) {
        this.dataObj.orgIdList = this.postKeys
        this.dataObj.dataScopeType = this.dataScopeType
      } else {
        this.dataObj.orgIdList = []
        this.dataObj.dataScopeType = null
      }

      if (this.dataObj.dataScope) {
        this.isSubmit = true
        if (this.dataObj.dataScope == 8) {
          if (this.dataObj.orgIdList == undefined || this.dataObj.orgIdList.length <= 0) {
            this.$message.warning('请选择岗位')
            this.isSubmit = false
          }
        }
      } else {
        this.$message.warning('请选择数据范围')
        this.isSubmit = false
      }
    },
    afterSaveData() {
      this.dialogVisible = false
      this.dataDialog = false
      this.$refs.roleTable.load()
    },
    async beforeSaveReport() {
      if (this.reportObj.reportScope) {
        this.isSubmit = true
      } else {
        this.$message.warning('请选择数据范围')
        this.isSubmit = false
      }
    },
    afterSaveReport() {
      this.dialogVisible = false
      this.reportDialog = false
      this.$refs.roleTable.load()
    },
    afterLoadData(data) {
      // 菜单权限复制
      if (this.dialogVisibleMenuPerm) {
        this.allowRoles = data
      }
      // 编辑角色
      if (this.dialogVisible) {
        this.role = data.value
        setTimeout(() => this.$validator.validateAll('editRoleForm'))
      }
    },
    exportMenu(row) {
      const loading = this.$loading({
        lock: true,
        text: '正在拼命下载。。。',
        spinner: 'el-icon-loading',
        background: 'rgba(0, 0, 0, 0.7)'
      })
      this.$http.get('${portal}/sys/sysMenu/v1/export?roleAlias=' + row.code + '&roleName=' + row.name, 'arraybuffer').then((resp) => {
        loading.close()
      })
    }
  }
}
</script>
<style scoped>
div[aria-invalid='true'] >>> .el-input__inner,
div[aria-invalid='true'] >>> .el-input__inner:focus {
  border-color: #f56c6c;
}
.dataBtn {
  margin-left: 16px;
}
.dataBtn:hover {
  background-color: #ebf2ff;
  color: #377cfe;
  border-color: #c3d8ff;
}
.dropdownBtn {
  margin-left: 16px;
}
.dropdown1 {
  margin-left: 10px;
  border-left: 1px solid #dcdfe6;
}
::v-deep .el-select__tags-text {
  max-width: 200px;
}
::v-deep .el-tag {
  max-width: 200px;
  display: table;
  white-space: pre-wrap;
}
.dataObjHeight {
  border-radius: 4px;
  border: 1px solid #dcdfe6;
  padding: 10px;
  height: 600px;
  overflow-y: scroll;
}
.dataJues {
  margin-left: 10px;
}
</style>
